import { CREATE_ALLOCATOR_NETWORKS, DELETE_ALLOCATOR_NETWORKS, GET_ALLOCATOR_NETWORKS, GET_ALLOCATOR_NETWORK_STATS, GET_ALLOCATOR_USERS, GET_INVESTOR_TYPE, UPDATE_ALLOCATOR_NETWORKS } from "./constants";


export function getAllocatorNetworks(payload) {
    return {
      type: GET_ALLOCATOR_NETWORKS,
      payload,
    };
  }
  
  export function getAllocatorNetworkStats() {
    return {
      type: GET_ALLOCATOR_NETWORK_STATS,
    };
  }
  
  export function createAllocatorNetworks(payload) {
    return {
      type: CREATE_ALLOCATOR_NETWORKS,
      payload,
    };
  }

  export function updateAllocatorNetworks(payload) {
    return {
      type: UPDATE_ALLOCATOR_NETWORKS,
      payload,
    };
  }

  export function getInvestorTypes() {
    return {
      type: GET_INVESTOR_TYPE,
    };
  }
  
  export function deleteAllocatorNetwork(payload) {
    return {
      type: DELETE_ALLOCATOR_NETWORKS,
      payload
    };
  }

  export function getAllocatorUsers(payload) {
    return {
      type: GET_ALLOCATOR_USERS,
      payload
    };
  }